document.addEventListener("DOMContentLoaded", function () {
  const menuIcon = document.getElementById("menu-icon"); // Ícone do menu
  const allDetails = document.querySelectorAll("details");

  menuIcon.addEventListener("click", function () {
    allDetails.forEach((detail) => {
      detail.removeAttribute("open"); // Fecha o <details>
    });
  });
});

//menu

document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".header__menus-item");

  menuItems.forEach((menuItem) => {
    const menuBox = menuItem.querySelector(".header__menus-sessao");
    const label = menuItem.querySelector(".header__menus-link");

    let isHovering = false;

    const showMenu = () => {
      menuBox.style.display = "flex";
      label.classList.add("ativo");
    };

    const hideMenu = () => {
      if (!isHovering) {
        menuBox.style.display = "none";
        label.classList.remove("ativo");
      }
    };

    menuItem.addEventListener("mouseenter", () => {
      isHovering = true;
      showMenu();
    });

    menuItem.addEventListener("mouseleave", () => {
      isHovering = false;
      setTimeout(hideMenu, 100);
    });

    menuBox.addEventListener("mouseenter", () => {
      isHovering = true;
      showMenu();
    });

    menuBox.addEventListener("mouseleave", () => {
      isHovering = false;
      setTimeout(hideMenu, 100);
    });
  });
});

//tagueamento
const pagina = localStorage.getItem("pagina");

const paraVoce = document.querySelectorAll(
  ".para_voce:first-child .header__menus__links-link"
);

paraVoce.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:para-voce`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar5: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const paraVoceMobile = document.querySelectorAll(
  ".para_voce_mobile .header-mobile__menus__links-link"
);

paraVoceMobile.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:para-voce`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar5: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const paraParceiros = document.querySelectorAll(
  ".para_parceiros:first-child .header__menus__links-link"
);

paraParceiros.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:para-parceiros`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar6: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const paraParceirosMobile = document.querySelectorAll(
  ".para_parceiros_mobile .header-mobile__menus__links-link"
);

paraParceirosMobile.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:para-parceiros`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar6: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const informacoes = document.querySelectorAll(
  ".informacoes:first-child .header__menus__links-link"
);

informacoes.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:informacoes`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar8: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const informacosMobile = document.querySelectorAll(
  ".informacoes_mobile .header-mobile__menus__links-link"
);

informacosMobile.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:informacoes`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar8: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const servicos = document.querySelectorAll(
  ".servicos:first-child .header__menus__links-link"
);

servicos.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:servicos`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar7: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const servicosMobile = document.querySelectorAll(
  ".servicos_mobile .header-mobile__menus__links-link"
);

servicosMobile.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:servicos`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar7: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const ajuda = document.querySelectorAll(
  ".ajuda:first-child .header__menus__links-link"
);

ajuda.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:ajuda`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar9: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const ajudaMobile = document.querySelectorAll(
  ".ajuda_mobile .header-mobile__menus__links-link"
);

ajudaMobile.forEach((link) => {
  link.addEventListener(
    "click",
    function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const itemSelecionado = this.textContent.trim();

      preencherLibSat("select", {
        event: `event:${pagina}:home:selecionou:ajuda`,
        contentGroupping: `fin:${pagina}`,
        page: `fin:${pagina}:home`,
        eventCategory: `fin:${pagina}:home:header`,
        eventAction: "selecionou",
        eventLabel: itemSelecionado,
        eVar9: itemSelecionado,
      });

      const href = this.getAttribute("href");
      if (href && href !== "#") {
        LibSatUtil.navigateSafely(href);
      }
    },
    { once: true }
  );
});

const area_cliente_tag = document.querySelector(".area_cliente");
area_cliente_tag.addEventListener("click", function (e) {
  e.preventDefault();

  preencherLibSat("click", {
    event: `event:${pagina}:home:clicou:botao:area-cliente`,
    contentGroupping: `fin:${pagina}`,
    page: `fin:${pagina}:home`,
    eventCategory: `fin:${pagina}:home:header`,
    eventAction: "clicou",
    eventLabel: "botao:area-cliente",
  });

  const href = area_cliente_tag.getAttribute("href");
  if (href && href !== "#") {
    window.location.href = href;
  }
});


